import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "../pages/Home.css";
import logo from "../../src/assets/servizy-logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const headerRef = useRef(null); // ✅ useRef

  useEffect(() => {
    const handleScroll = () => {
      if (!headerRef.current) return; // ✅ safety check

      if (window.scrollY > 40) {
        headerRef.current.classList.add("header-scrolled");
      } else {
        headerRef.current.classList.remove("header-scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      ref={headerRef} // ✅ attach ref
      className={`main-header ${menuOpen ? "menu-open" : ""}`}
    >
      <div className="nav-container">

        {/* Logo */}
        <NavLink to="/" className="logo" onClick={closeMenu}>
          <img src={logo} alt="Logo" className="logo-img" />
        </NavLink>

        {/* Hamburger */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <NavLink to="/" onClick={closeMenu}>Home</NavLink>
          <NavLink to="/about" onClick={closeMenu}>About</NavLink>
          <NavLink to="/services" onClick={closeMenu}>Services</NavLink>
          <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>

          <button
            className="book-btn"
            onClick={() => {
              closeMenu();
              sessionStorage.removeItem("bookingCustomer");
              navigate("/login", { replace: true });
            }}
          >
            BOOK NOW
          </button>
        </nav>

      </div>
    </header>
  );
};

export default Header;